export const MARGIN_RANGE = {
  min: 0,
  max: 10,
};
